function sanitize(data) {
  if (data) {
    if (Array.isArray(data)) {
      return data.map((el) => {
        let attributes = el.attributes;
        if (!attributes) attributes = {};

        attributes.id = el.id;
        if (attributes) {
          const keys = Object.keys(attributes);
          for (var a = 0; a < keys.length; a++) {
            if (attributes[keys[a]] && attributes[keys[a]].data) {
              attributes[keys[a]] = sanitize(attributes[keys[a]].data);
            }
          }
          return attributes;
        } else {
          return null;
        }
      });
    } else {
      // if(data.data)
      let attributes = data.attributes;
      if (!attributes) attributes = {};
      const keys = Object.keys(attributes);
      for (var a = 0; a < keys.length; a++) {
        if (attributes[keys[a]] && attributes[keys[a]].data) {
          attributes[keys[a]] = sanitize(attributes[keys[a]].data);
        }
      }
      return { id: data.id, ...data.attributes };
    }
  }
}

var functions = {
  sanitize,
};

export default functions;
